import React, { useCallback, useState, useEffect, useRef } from 'react';
import Button from '../common/button';
import TextInput from '../common/text-input';

import '../../styles/toolbar.scss';
import FilterMenu from './filter-menu';

export default function Toolbar(props) {
  const [shouldShowFilterMenu, setShouldShowFilterMenu] = useState(false)
  const [searchValue, setSearchValue] = useState(props.searchTerm || '')
  const searchTimeoutRef = useRef(null)

  const handleSearchInput = useCallback((e) => {
    const value = e.target.value
    setSearchValue(value)

    // Clear existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current)
    }

    // Set new timeout for 500ms delay
    searchTimeoutRef.current = setTimeout(() => {
      props.onSearchChange(value)
    }, 500)
  }, [props])

  // Clear timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current)
      }
    }
  }, [])

  return (
    <div className='ToolbarContainer Questions'>
      <Button
        text="New Question"
        onClick={()=>{props.openNewQuestionModal()}}
      />
      <div className='ToolbarContainer_searchWrapper'>
        <TextInput
          placeholder="Enter text to search"
          value={searchValue}
          onInput={handleSearchInput}
        />
        {/* <button>Search Settings</button> */}
      </div>

      <FilterMenu
        selectedFilterTags={props.selectedFilterTags}
        setSelectedFilterTags={props.setSelectedFilterTags}
        selectedFilterOwners={props.selectedFilterOwners}
        setSelectedFilterOwners={props.setSelectedFilterOwners}
        setShouldShowFilterMenu={setShouldShowFilterMenu}
        shouldShowFilterMenu={shouldShowFilterMenu}
        search={props.search}
      >
        <Button
          text="Filter Results"
          onClick={() => {setShouldShowFilterMenu(!shouldShowFilterMenu)}}
          customClass='ToolbarContainer_filterButton'
        >
          {(props.selectedFilterTags.length > 0 || props.selectedFilterOwners.length > 0) &&
            <span className='ToolbarContainer_filterCounter'>
              {props.selectedFilterTags.length + props.selectedFilterOwners.length}
            </span>
          }
        </Button>
      </FilterMenu>
      <div className='ToolbarContainer_questionsCount'>
        Displaying {props.total} question{props.total === 1 ? '' : 's'}
      </div>
    </div>
  );
};